export default __webpack_public_path__ + "static/media/julian.a32845f4.svg";